module.exports = __webpack_public_path__ + "static/gallery-img-19-78a03b7e43af3044f30befb347aebcee.jpg";